<template>
  <div class="flex flex-row pin-t border border-b border-grey-lightest h-12 w-screen shadow z-20 justify-between" >
    <div class="flex flex-row items-center justify-start">
      <router-link to="/admin-home" class="no-underline">
        <img class="w-32 ml-4" src="../../assets/ekincare_logo.png"/>
      </router-link>
    </div>
    <div class="flex flex-row items-center justify-end">
      <span class=" ml-4 mr-4">
        {{doctor.name}}
      </span>
      <span class="cursor-pointer mx-4 mt-1 self-center" @click="logout">
        <img src="../../assets/sign_out.svg" style="height:25px">
      </span>
    </div>
  </div>
</template>

<script>
import router from '../../router/index.js'
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      doctorName: sessionStorage.getItem('name'),
      currentStatus: sessionStorage.getItem('chatstatus') ? sessionStorage.getItem('chatstatus') : 'unavailable',
      role: sessionStorage.getItem('role'),
      company_id: JSON.parse(sessionStorage.getItem('company_id')),
      logOut: false
    }
  },
  computed: {
    ...mapGetters({
      doctor: 'configuration/doctor'
    })
  },
  methods: {
    logout: function () {
      sessionStorage.clear()
      // ably.close()
      this.$store.dispatch('clearAll')
      router.go('/logout')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/AdminNavbar.vue